//import { List } from 'immutable';
import { slugify } from '../../utils/format';

const SET_SLUG = 'cities/SET_SLUG';
const LOAD = 'cities/LOAD';
const LOAD_SUCCESS = 'cities/LOAD_SUCCESS';
const LOAD_FAIL = 'cities/LOAD_FAIL';

const initialState = {
  list: [],
  aliases: new Map(),
  current: null,
  slug: null
};

export default function cities(state = initialState, action) {
  if (action.type === SET_SLUG) {
    const slug = action.payload;
    const current = state.list.filter(item => item.slug === slug)[0];
    return { ...state, slug, current };
  }
  if (action.type === LOAD_SUCCESS) {
    const list = action.payload;
    const current = state.slug
      ? list.filter(item => item.slug === state.slug)[0]
      : state.current;
    return { ...state, list, current };
  }
  return state;
}

export function isLoaded(globalState) {
  return globalState.cities.list.length;
}

export function getCities() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get('/api/dwellings/areas')
  };
}

export function setCitySlug(slug) {
  return {
    type: SET_SLUG,
    payload: slugify(slug)
  };
}

export function serialize({ list, ...state }) {
  return {
    ...state,
    list: list.map(area => [area.label, area.active ? 1 : 0, area.zip])
  };
}

export function deserialize({ list, ...state }) {
  const aliases = new Map();
  const arr = list.map(area => {
    if (!area[2].length) {
      aliases.set(area[0], area[0]);
    }
    return {
      label: area[0],
      slug: slugify(area[0]),
      active: Boolean(area[1]),
      zip: area[2].map(item => {
        aliases.set(item, area[0]);
        return item;
      })
    };
  });

  return {
    ...state,
    list: arr,
    aliases
  };
}
